<div class='configuration-email-jobs-page'>

	<toolbar icon='Configuration'>

		<droplist [items]='[]' [popupConfig]='popupConfig' [navigation]='true'>
		</droplist>

		<div style='display:inline-block;width:300px'>
			<trimester-droplist [trimesterWindow]="trimesterWindow"></trimester-droplist>
		</div>
		<!-- 
		<button class="btn btn-light">
			<icon-text [iconContext]='{ text: "Monkey", iconClass: "fa-monkey", iconStyle:"fa-regular", hideText: "lt-md" }'></icon-text>
		</button>

		<button class="btn btn-light">
			<icon-text [iconContext]='{ text: "Pizza", iconClass: "fa-pizza-slice", iconStyle:"fa-regular", hideText: "lt-lg" }'></icon-text>
		</button> -->

	</toolbar>

	<page-tabs [tabNames]='["Email Jobs", "Tab1", "Tab2"]' [pageService]='pageService' (layoutChange)='onLayoutChange($event)'>
		<ng-template pageTab1>
			<configuration-email-jobs-views-part></configuration-email-jobs-views-part>
		</ng-template>

		<ng-template pageTab2>
			<configuration-email-jobs-tab-1-part></configuration-email-jobs-tab-1-part>
		</ng-template>

		<ng-template pageTab3>
			<configuration-email-jobs-tab-2-part></configuration-email-jobs-tab-2-part>
		</ng-template>
	</page-tabs>

</div>